import type { Schema } from '@cli-types/core-engine/schema.js'
import { singularizeLabel } from '@cli-utils/text.js'

export interface DisplayNouns {
  singular: string
  plural: string
}

export function resolveDisplayNouns(schema: Schema): DisplayNouns {
  return {
    singular: schema.labelSingular ?? singularizeLabel(schema.label),
    plural: schema.labelPlural ?? schema.label
  }
}
